// fleet-generated: do not edit by hand
//
// Copied verbatim  : infra/fleet/artifacts/feature-notifications/plugin.ts
// Parameters       : none — below this header, identical across the fleet
// Destination      : packages/fleet/plugins/src/notifications/index.ts
//
// TO CHANGE THIS FILE, edit the canonical copy in infra and re-render. It
// changes for the whole fleet at once. Editing it here is reverted by the
// next render, and the guard in this repo goes red in the meantime:
//
//     cd ../infra && node fleet/fleet.ts render --repo bible-strong-offline-app
//     node fleet/fleet.ts check --repo bible-strong-offline-app
//
// The generator runs LOCALLY and is never invoked by CI. CI only verifies
// that what is committed matches the hash in .github/fleet-lock.json, which
// also records WHICH infra commit produced it. The commit is deliberately
// not repeated here: one value, one place — and stamping it into every file
// meant a one-line template edit rewrote four files in 28 repos.
/**
 * `plugins/notifications` — one folder, one plugin, everything it owns.
 *
 * NOTIFICATIONS as a client kernel plugin (feature #10 of Round 2).
 *
 * Criterion (VEREDICTO §1): a plugin, because it schedules work that survives
 * render and must be torn down on account switch / logout.
 */
import { type Plugin, serviceToken } from "@fleet/kernel";

export interface NotificationServiceHandle {
  cancelAll?: () => Promise<void> | void;
}

export const NOTIFICATIONS = serviceToken<NotificationServiceHandle>("notifications");

export interface NotificationsPluginConfig {
  service?: NotificationServiceHandle;
  onTeardown?: () => Promise<void> | void;
}

export const notificationsPlugin: Plugin<NotificationsPluginConfig> = {
  id: "notifications",
  provides: [NOTIFICATIONS],
  capabilities: ["notifications"],

  data(ctx) {
    const handle: NotificationServiceHandle = ctx.config.service ?? {};
    ctx.provide(NOTIFICATIONS, handle);

    ctx.addCleanup(() => {
      void (ctx.config.onTeardown ? ctx.config.onTeardown() : handle.cancelAll?.());
    });
    ctx.log("notifications_ready");
  },
};
